import { string } from 'prop-types'
import { useContext } from 'react'
import { MembershipContext } from 'ui/contexts'
import ProtectedRoute from '../ProtectedRoute'

const ProtectedBySuperAdmin = ({ redirectPath }) => {
  const { role } = useContext(MembershipContext)
  const { superAdmin } = role || {}

  return <ProtectedRoute isAllowed={superAdmin} redirectPath={redirectPath} />
}

ProtectedBySuperAdmin.propTypes = {
  redirectPath: string.isRequired,
}

ProtectedBySuperAdmin.defaultProps = {}

export default ProtectedBySuperAdmin
